import React from "react";
import { Box, Collapse, IconButton } from "@mui/material";
import { colors } from "../assets/colors";
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';

interface Props {
  title: string;
  children: React.ReactNode;
  open?: boolean;
  iconDelete?: React.ReactNode;
  iconEdit?: React.ReactNode;
  iconAdd?: React.ReactNode;
  moreInfo?: React.ReactNode;
  actionDelete?: () => void;
  actionEdit?: () => void;
  actionAdd?: () => void;
}

export default function CollapseCard(props: Props) {

  const [open, setOpen] = React.useState(props.open || false);

  return (
    <Box sx={{ border: '1px solid #e5e5e5', padding: 0 }}>
      <Box sx={styles.content} >
        <IconButton size="medium" onClick={() => setOpen(!open)} >
          {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
        </IconButton>

        <span style={styles.suiteTitle} onClick={() => setOpen(!open)}>
          {props.title}
          {props.moreInfo}
        </span>

        {props.iconAdd &&
          <IconButton style={styles.button} onClick={props.actionAdd}>
            {props.iconAdd}
          </IconButton>
        }

        {props.iconEdit &&
          <IconButton style={styles.button} onClick={props.actionEdit}>
            {props.iconEdit}
          </IconButton>
        }
        {props.iconDelete &&
          <IconButton style={styles.button} onClick={props.actionDelete}>
            {props.iconDelete}
          </IconButton>
        }
      </Box>

      <Collapse in={open} timeout="auto" style={styles.testCasesContainer}>
        {props.children}
      </Collapse>
    </Box>
  );
}

const styles = {
  content: {
    display: "flex",
    alignItems: "center",
    justifyContent: "left",
    backgroundColor: colors.background,
    width: "100%",
    padding: 2,
    borderRadius: 1,
    position: "sticky",
    top: 0,
    zIndex: 999,
  },

  suiteTitle: {
    marginLeft: 12,
    marginRight: 24,
    fontSize: 18,
    fontWeight: "600",
    color: colors.black,
    cursor: "pointer",
  },

  button: {
    display: 'flex',
    width: 32,
    height: 32,
    marginLeft: 6
  },

  testCasesContainer: {
    marginTop: 12
  }

}